import { jsx } from 'react/jsx-runtime';
import { Component } from 'react';
import cns from '../../node_modules/classnames/index.js';
import FormContext from './FormContext.js';
import useFormState from '../Hooks/useFormState.js';
import useForm from '../Hooks/useForm.js';

/**
Componente per raggruppare componenti di input.

Per eseguire una validazione della form, utilizzare il metodo `valida()` della reference.

_Nota: se usate gli hooks vedi `Form.useFormState` per la gestione dello stato, vedi `Form.useForm` per la gestione del contesto delle form._

 */
class Form extends Component {
    constructor(props) {
        super(props);
        this.addToForm = (name, value, callback) => {
            this.validationState[name] = value;
            this.errori[name] = [];
            this.subscriptions[name] = callback;
            this.struttura.All = (this.struttura.All || []).concat(name);
            this.rivalida();
        };
        this.removeFromForm = (name) => {
            delete this.validationState[name];
            delete this.errori[name];
            delete this.subscriptions[name];
            const position = this.struttura.All.indexOf(name);
            if (~position) { // eslint-disable-line no-bitwise
                this.struttura.All.splice(position, 1);
            }
            this.rivalida();
        };
        this.resetta = () => {
            this.setState({
                validare: false,
            });
            Object.keys(this.subscriptions).forEach((prop) => prop != null
                && this.subscriptions[prop] != null && this.subscriptions[prop]());
        };
        // API pubblica
        this.valida = () => {
            this.setState({
                validare: true,
            });
            return this.isValid;
        };
        this.rivalida = () => {
            const { onValidationChange } = this.props;
            let nuovaValidita = true;
            Object.keys(this.validationState).forEach((x) => {
                nuovaValidita = nuovaValidita && this.validationState[x];
            });
            if (this.isValid !== nuovaValidita) {
                this.isValid = nuovaValidita;
                if (onValidationChange) {
                    setTimeout(() => onValidationChange(this.isValid));
                }
            }
        };
        this.updateValidationState = (field, isValid, messages) => {
            const { onChange } = this.props;
            this.validationState[field] = isValid;
            const uguali = (this.errori[field] || []).length === messages.length
                && (this.errori[field] || []).every((v, i) => v === messages[i]);
            if (!uguali) {
                this.errori[field] = messages;
                const errori = Object.assign({}, this.errori);
                setTimeout(() => onChange({ FormErrors: errori }));
            }
            this.rivalida();
        };
        this.state = {
            validare: false,
        };
        this.validationState = {};
        this.subscriptions = {};
        this.errori = {};
        this.struttura = {};
        this.isValid = true;
    }
    getFormContext() {
        const { onChange, stato } = this.props;
        const { validare } = this.state;
        if (!this.formContext
            || this.formContext.onFormChange !== onChange
            || this.formContext.stato !== stato
            || this.formContext.validare !== validare) {
            this.formContext = {
                addToForm: this.addToForm,
                isValid: this.updateValidationState,
                onFormChange: onChange,
                removeFromForm: this.removeFromForm,
                resetta: this.resetta,
                stato,
                validare,
            };
        }
        return this.formContext;
    }
    render() {
        const { children, className } = this.props;
        const classes = cns('form', className);
        return (jsx(FormContext.Provider, { value: this.getFormContext(), children: jsx("div", { className: classes, children: children }) }));
    }
}
Form.defaultProps = {
    className: undefined,
    onValidationChange: undefined,
};
Form.useFormState = useFormState;
Form.useForm = useForm;

export { Form as default };
